import api from './api';

export interface TaepGrupo {
  grupo: string;
  pontos: number;
  maximo: number;
  percentual: number;
  peso: number;
}

export interface TaepItem {
  codigo: string;
  grupo: string;
  titulo: string;
  nota?: number;
  justificativa?: string;
  evidenciaUrl?: string;
  evidenciaVerificadaEm?: string;
  arquivoNome?: string;
  arquivoUrl?: string;
  providenciaAcao?: string;
  providenciaResponsavel?: string;
  providenciaUnidade?: string;
  providenciaInicio?: string;
  providenciaTermino?: string;
  atualizadoPor?: string;
  atualizadoEm?: string;
  alertas: string[];
}

export interface TaepResultado {
  exercicio: number;
  itens: TaepItem[];
  grupos: Record<string, TaepGrupo>;
  pontuacaoConsolidada: number;
  faixa: string;
  totalPendencias: number;
}

export type TaepItemInput = Pick<TaepItem,
  'nota' | 'justificativa' | 'evidenciaUrl' | 'evidenciaVerificadaEm' |
  'providenciaAcao' | 'providenciaResponsavel' | 'providenciaUnidade' |
  'providenciaInicio' | 'providenciaTermino'>;

export interface TaepDossie {
  exercicio: number;
  pontuacao: number;
  prontoParaEnvio: boolean;
  pendencias: string[];
  unidadeResponsavel?: string;
  atoDesignacaoUrl?: string;
  leiOrganicaUrl?: string;
  loaUrl?: string;
  creditosUrl?: string;
  listaEmendasUrl?: string;
  responsavelEnvio?: string;
  prazoEnvio?: string;
  canalEnvio?: string;
  revisaoPlanejamento: boolean;
  revisaoFinancas: boolean;
  revisaoControleInterno: boolean;
  revisaoTransparencia: boolean;
  revisaoTi: boolean;
  revisaoLicitacoes: boolean;
  revisaoConvenios: boolean;
  observacoes?: string;
}

export const taepService = {
  async obter(exercicio: number): Promise<TaepResultado> {
    return (await api.get<TaepResultado>(`/taep/avaliacoes/${exercicio}`)).data;
  },

  async salvar(exercicio: number, codigo: string, input: TaepItemInput): Promise<TaepItem> {
    return (await api.put<TaepItem>(`/taep/avaliacoes/${exercicio}/${codigo}`, input)).data;
  },

  async enviarArquivo(exercicio: number, codigo: string, file: File): Promise<TaepItem> {
    const body = new FormData();
    body.append('file', file);
    return (await api.post<TaepItem>(`/taep/avaliacoes/${exercicio}/${codigo}/arquivo`, body, {
      headers: { 'Content-Type': 'multipart/form-data' },
    })).data;
  },

  async baixarArquivo(exercicio: number, codigo: string): Promise<Blob> {
    return (await api.get(`/taep/avaliacoes/${exercicio}/${codigo}/arquivo`, { responseType: 'blob' })).data;
  },

  async obterDossie(exercicio: number): Promise<TaepDossie> {
    return (await api.get<TaepDossie>(`/taep/avaliacoes/${exercicio}/dossie`)).data;
  },

  async salvarDossie(exercicio: number, input: TaepDossie): Promise<TaepDossie> {
    return (await api.put<TaepDossie>(`/taep/avaliacoes/${exercicio}/dossie`, input)).data;
  },

  async exportarDossie(exercicio: number): Promise<Blob> {
    return (await api.get(`/taep/avaliacoes/${exercicio}/dossie.csv`, { responseType: 'blob' })).data;
  },
};
